import {
  LdBadge,
  LdButton,
  LdIcon,
  LdTableCell,
  LdTableRow,
} from '@emdgroup-liquid/liquid/dist/react';
import classNames from 'classnames';
import { tableColumns } from 'components/ChemicalSpace/TargetList/tableColumns';
import React from 'react';
import { TargetVariable } from 'types/api/types';

interface TargetTableItemRowProps {
  target: TargetVariable;
  isEditing?: boolean;
  hasError?: boolean;
  readOnly?: boolean;
  onRemoveClick?: () => void;
  onEditClick?: () => void;
}

export const TargetTableItemRow: React.FC<TargetTableItemRowProps> = ({
  target,
  isEditing,
  hasError,
  readOnly,
  onRemoveClick,
  onEditClick,
}) => {
  return (
    <LdTableRow
      className={classNames({
        'bg-rich-purple-lightest': isEditing,
        'bg-rich-red-lightest': hasError,
      })}
    >
      {tableColumns.map(({ key }) => (
        <LdTableCell className="py-1 px-4 text-left" key={key}>
          {target[key]}
        </LdTableCell>
      ))}

      {!readOnly && (
        <LdTableCell className="py-1 px-4 text-left flex items-center justify-center">
          {!isEditing ? (
            <div className="flex flex-0 items-center justify-center gap-ld-2">
              {!!onRemoveClick && (
                <LdButton
                  type="button"
                  className="flex"
                  onClick={() => onRemoveClick()}
                  mode="danger-secondary"
                  size="sm"
                >
                  <LdIcon name="cross" />
                </LdButton>
              )}
              {!!onEditClick && (
                <LdButton
                  type="button"
                  onClick={() => onEditClick()}
                  size="sm"
                  className="flex"
                  mode="secondary"
                >
                  <LdIcon name="pen" />
                </LdButton>
              )}
            </div>
          ) : (
            <LdBadge>Editing...</LdBadge>
          )}
        </LdTableCell>
      )}
    </LdTableRow>
  );
};
